// libaries
import { CSSProperties } from "@material-ui/core/styles/withStyles";

// assets
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires
const eventMismatchSvg = require("./assets/event-mismatch.svg");

const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: 450,
  height: "100%",
  margin: "auto",
  padding: 24,
};

const eventMissingImage: CSSProperties = {
  backgroundImage: `url(${eventMismatchSvg})`,
  backgroundSize: "contain",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  width: "100%",
  maxWidth: 300,
  height: 175,
  marginBottom: 24,
};

const h6: CSSProperties = {
  textAlign: "center",
  fontSize: "18px",
  lineHeight: 1.6,
};

export const styles = {
  container,
  eventMissingImage,
  h6,
};
